// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-skeleton[data-v-4c6da070]{display:flex;justify-content:center;align-items:center;min-height:100vh;margin-top:-76px}", ""]);
// Exports
module.exports = exports;
